import type { App } from "@upsquad/server";
import type { CommunityContactFormPayload } from "@upsquad/shared";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type SubmitCommunityContactResponse = App["~Routes"]["community-contact"][":slug"]["post"]["response"]["200"];

export const contactApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		submitCommunityContact: builder.mutation<SubmitCommunityContactResponse, { slug: string; payload: CommunityContactFormPayload }>({
			query:
				({ slug, payload }): EdenCall<SubmitCommunityContactResponse> =>
				(client) =>
					client["community-contact"]({ slug }).post(payload),
		}),
	}),
});

export const { useSubmitCommunityContactMutation } = contactApi;
